import { module as BaseModule } from 'modujs';
import gsap from 'gsap';

import { body } from '../utils/dom';

export default class extends BaseModule {
  constructor(m) {
    super(m);

    this.observer = null;
    this.langSelector = document.querySelector('.c-language-selector');
  }

  init() {

    if (!window.IntersectionObserver) {
      this.destroy();
      return;
    }

    this.observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.el.classList.add('is-white');
          this.langSelector.classList.add('is-white');
          //entry.target.classList.add('is-visible');
          //this.destroyWhenObserved( entry.target );
          //observer.unobserve(entry.target); // uncomment to animate once
        } else {
          this.el.classList.remove('is-white');
          this.langSelector.classList.remove('is-white');
          //entry.target.classList.remove('is-visible');
        }
      });
    }, {
      rootMargin: '-100px 0px 0px',
      threshold: 0.0
    });

    if ( body.classList.contains('home') ) {
      this.observer.observe( body.querySelector('[data-module-hero]') );
    }

    gsap.to( this.el, {
      duration: 0.5,
      delay: 2.0,
      opacity: 1,
      y: 0,
    } );

  }
}
